import React, { useState,useEffect } from 'react';
import { authService } from '../../services/api';
import { Visibility as FaEye, VisibilityOff as FaEyeSlash, Margin } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Alert } from '@mui/material';
import axios from 'axios';
const PasswordInput = ({ value, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);
 
  const togglePasswordVisibility = () => {
    setShowPassword(prevState => !prevState);
  };
 
  return (
    <div className="form-group">
      <h2>Password</h2>
      <div className="input-outer" style={{ position: "relative" }}>
        <input
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          className="form-control"
          placeholder="********"
          required
          style={{ paddingRight: "40px" }} // Space for the eye icon
        />
        <button
          type="button"
          className="toggle-password"
          onClick={togglePasswordVisibility}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0
          }}
        >
          {/*{showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}*/}
          <div>
            {showPassword ? <a style={{color:'var(--primary-color)', textDecoration:'none',fontSize:'14px'}}>Hide</a> : <a style={{color:'var(--primary-color)',textDecoration:'none',fontSize:'14px'}}>Show</a>}
          </div>
        </button>
      </div>
    </div>
  );
};
 
const Login = ({ isEmbedded = false}) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [logoUrl, setLogoUrl] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const isEmbeddedPath = window.location.pathname.startsWith('/embed');

  // Function to get embed information
  const getEmbedInfo = () => {
    let embedToken = null;
  
    // Method 1: Direct window property (for script-based embeds)
    embedToken = window.BEETSOL_EMBED_TOKEN;
    
    if (!embedToken) {
      const urlParams = new URLSearchParams(window.location.search);
      embedToken = urlParams.get('token');
    }

    const isEmbeddedLogin = isEmbedded || isEmbeddedPath || !!embedToken;

    return {
      isEmbedded: isEmbeddedLogin,
      embedToken: embedToken,
      embedDomain: isEmbeddedLogin ? (document.referrer ? new URL(document.referrer).hostname : window.location.hostname) : null,
      embedReferrer: isEmbeddedLogin ? document.referrer : null,
      userAgent: navigator.userAgent
    };
  };

useEffect(() => {
  const fetchLogo = async () => {
    try {
      const res = await axios.get('/api/settings/logo'); 
      if (res.data.success && res.data.logoUrl) {
        setLogoUrl(res.data.logoUrl);
      } else {
        setLogoUrl(null);
      }
    } catch (err) {
      console.error("Failed to fetch logo", err);
      setLogoUrl(null);
    }
  };

  fetchLogo();
}, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      // Get embed information
      const embedInfo = getEmbedInfo();
     
      // Prepare login data with embed context
      const loginData = {
        ...formData,
        embedContext: embedInfo
      };      

      const response = await authService.login(loginData);
      if (response.data.success) {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('userData', JSON.stringify(response.data.user));

        // Store embed context in localStorage for future reference
        if (embedInfo.isEmbedded) {
          localStorage.setItem('embedContext', JSON.stringify(embedInfo));
        }

        if (isEmbedded || isEmbeddedPath) {
          if (response.data.user.role_id === 2) { //  role_id 2 is for learners
            // Keep the embed parameters (the token among them): the /embed page is only shown inside the token's
            // sites (K13, frame-ancestors). Removed 11 Oct 2026 (K13): reloading /embed/dashboard without them.
            window.location.href = `/embed/dashboard${window.location.search}`;
          } else {
            setError('Only learners can access this content');
            localStorage.removeItem('isAuthenticated');
            localStorage.removeItem('userData');
            localStorage.removeItem('embedContext');
          }
        } else {
          window.location.href = '/dashboard';
        }
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Login failed');
      setFormData(prev => ({ ...prev, password: '' }));
    } finally {
      setIsLoading(false);
    }
  };
 
  return (
    <div className={`login-page ${isEmbedded ? 'embedded-login' : ''}`}>
      
      {!isEmbedded && (
        <div className="login-header">
          <div className="header-content">            
            <div className="logo-container">
              {/* <img src="/images/beetsol-logo.png" alt="Beetsol Logo" className="login-logo" /> */}
              <img
              src={logoUrl ? logoUrl : "/default-logo.png"}
              alt="Company Logo"
              style={{ width: "150px", height: "auto" }}
            />

            </div>              
            <h1>Welcome to Beetsol LMS</h1>
            <p>Take charge of your learning environment</p>
          </div>
        </div>
      )}
      <div className="login-container">        
        {isEmbedded && (
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h5">
              Sign in to access learning content
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Please log in with your learner account
            </Typography>
          </Box>
        )}
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit} className='login-form'>
          <div className="form-group">
            <h2>Email or Username</h2>
            <div className="input-outer">
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="form-control"
                placeholder="e.g. john@gmail.com"
                required
              />
            </div>
          </div>
 
          {/* Use the PasswordInput component here */}
          <PasswordInput
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
          />
 
          {!isEmbedded && (
            <div className="forgot-password">
              <a href="/forgot-password">Forgot Password?</a>
            </div>
          )}
          <div className="form-action">
            <button type="submit" className="login-btn" disabled={isLoading}>
              {isLoading ? 'Logging in...' : 'Login'}
            </button>
          </div>
        </form> 
        {isEmbedded && (
          <Box sx={{ textAlign: 'center', mt: 2 }}>
            <Typography variant="caption" color="textSecondary">
              This content is provided by Beetsol LMS
            </Typography>
          </Box>
        )}        
      </div>          
    </div>
  );
};
 
export default Login;
